/** Color variables. */
export const COLOR_VAR = {
  BLUE: 'var(--bs-blue)',
  INDIGO: 'var(--bs-indigo)',
  PURPLE: 'var(--bs-purple)',
  PINK: 'var(--bs-pink)',
  RED: 'var(--bs-red)',
  ORANGE: 'var(--bs-orange)',
  YELLOW: 'var(--bs-yellow)',
  GREEN: 'var(--bs-green)',
  TEAL: 'var(--bs-teal)',
  CYAN: 'var(--bs-cyan)',
  BLACK: 'var(--bs-black)',
  WHITE: 'var(--bs-white)',
  GRAY: 'var(--bs-gray)',
  GRAY_DARK: 'var(--bs-gray-dark)',
  GRAY_100: 'var(--bs-gray-100)',
  GRAY_200: 'var(--bs-gray-200)',
  GRAY_300: 'var(--bs-gray-300)',
  GRAY_400: 'var(--bs-gray-400)',
  GRAY_500: 'var(--bs-gray-500)',
  GRAY_600: 'var(--bs-gray-600)',
  GRAY_700: 'var(--bs-gray-700)',
  GRAY_800: 'var(--bs-gray-800)',
  GRAY_900: 'var(--bs-gray-900)',
  PRIMARY: 'var(--bs-primary)',
  SECONDARY: 'var(--bs-secondary)',
  TERTIARY: 'var(--bs-tertiary)',
  SUCCESS: 'var(--bs-success)',
  INFO: 'var(--bs-info)',
  WARNING: 'var(--bs-warning)',
  DANGER: 'var(--bs-danger)',
  LIGHT: 'var(--bs-light)',
  DARK: 'var(--bs-dark)',
  PRIMARY_TEXT_EMPHASIS: 'var(--bs-primary-text-emphasis)',
  SECONDARY_TEXT_EMPHASIS: 'var(--bs-secondary-text-emphasis)',
  SUCCESS_TEXT_EMPHASIS: 'var(--bs-success-text-emphasis)',
  INFO_TEXT_EMPHASIS: 'var(--bs-info-text-emphasis)',
  WARNING_TEXT_EMPHASIS: 'var(--bs-warning-text-emphasis)',
  DANGER_TEXT_EMPHASIS: 'var(--bs-danger-text-emphasis)',
  LIGHT_TEXT_EMPHASIS: 'var(--bs-light-text-emphasis)',
  DARK_TEXT_EMPHASIS: 'var(--bs-dark-text-emphasis)',
  PRIMARY_BG_SUBTLE: 'var(--bs-primary-bg-subtle)',
  SECONDARY_BG_SUBTLE: 'var(--bs-secondary-bg-subtle)',
  SUCCESS_BG_SUBTLE: 'var(--bs-success-bg-subtle)',
  INFO_BG_SUBTLE: 'var(--bs-info-bg-subtle)',
  WARNING_BG_SUBTLE: 'var(--bs-warning-bg-subtle)',
  DANGER_BG_SUBTLE: 'var(--bs-danger-bg-subtle)',
  LIGHT_BG_SUBTLE: 'var(--bs-light-bg-subtle)',
  DARK_BG_SUBTLE: 'var(--bs-dark-bg-subtle)',
  PRIMARY_BORDER_SUBTLE: 'var(--bs-primary-border-subtle)',
  SECONDARY_BORDER_SUBTLE: 'var(--bs-secondary-border-subtle)',
  SUCCESS_BORDER_SUBTLE: 'var(--bs-success-border-subtle)',
  INFO_BORDER_SUBTLE: 'var(--bs-info-border-subtle)',
  WARNING_BORDER_SUBTLE: 'var(--bs-warning-border-subtle)',
  DANGER_BORDER_SUBTLE: 'var(--bs-danger-border-subtle)',
  LIGHT_BORDER_SUBTLE: 'var(--bs-light-border-subtle)',
  DARK_BORDER_SUBTLE: 'var(--bs-dark-border-subtle)',
  GRADIENT: 'var(--bs-gradient)',
  BODY_COLOR: 'var(--bs-body-color)',
  BODY_BG: 'var(--bs-body-bg)',
  EMPHASIS_COLOR: 'var(--bs-emphasis-color)',
  SECONDARY_COLOR: 'var(--bs-secondary-color)',
  SECONDARY_BG: 'var(--bs-secondary-bg)',
  TERTIARY_COLOR: 'var(--bs-tertiary-color)',
  TERTIARY_BG: 'var(--bs-tertiary-bg)',
  LINK_COLOR: 'var(--bs-link-color)',
  LINK_HOVER_COLOR: 'var(--bs-link-hover-color)',
  CODE_COLOR: 'var(--bs-code-color)',
  HIGHLIGHT_COLOR: 'var(--bs-highlight-color)',
  HIGHLIGHT_BG: 'var(--bs-highlight-bg)',
  BORDER_COLOR: 'var(--bs-border-color)',
  BORDER_COLOR_TRANSLUCENT: 'var(--bs-border-color-translucent)',
  FOCUS_RING_COLOR: 'var(--bs-focus-ring-color)',
  FORM_VALID_COLOR: 'var(--bs-form-valid-color)',
  FORM_VALID_BORDER_COLOR: 'var(--bs-form-valid-border-color)',
  FORM_INVALID_COLOR: 'var(--bs-form-invalid-color)',
  FORM_INVALID_BORDER_COLOR: 'var(--bs-form-invalid-border-color)',
} as const;
